import { render, staticRenderFns } from "./templates-container.vue?vue&type=template&id=b41c8c7e"
import script from "./templates-container.vue?vue&type=script&lang=js"
export * from "./templates-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports